import { svg } from "lit";
const icon = svg `<path d="M5.65792 29.2465L4.1665 27.7551L15.5073 16.393L22.315 23.2007L32.3417 13.2551H26.9314V11.1611H35.8331V20.0628H33.7562V14.7636L22.2979 26.2326L15.4902 19.4249L5.65792 29.2465Z" fill="currentColor"/>`;
export default icon;
